<template>
	<div>
				<div class="row">
					<div class="col-md-4">
						<ListCompare title="SALES" unit="M" div=1000000 :data="ytd.sales.rekap" itemcol="Info" valuecol="Value" url="/bright-sales"/>
					</div>
					<div class="col-md-4">
						<ListCompare title="MARGIN" unit="%" :data="ytd.margin.rekap" itemcol="Info" valuecol="Value" url="/bright-sales"/>
					</div>
				</div>
	<div class="row">
			<div class="col-md-4">
				<BarCard title="SALES PER DAY (M)" :data="weekly.spd" :width="500" :height="280"/>
			</div>
			<div class="col-md-4">
				<BarCard title="SALES EX TAX (M)" :data="weekly.sales" :width="500" :height="280"/>
			</div>
			<div class="col-md-4">
				<BarCard title="MARGIN (%)" :data="weekly.margin" :width="500" :height="280"/>
			</div>
			<div class="col-md-4">
				<BarCard title="NO OF INVOICE" :data="weekly.inv" :width="500" :height="280"/>
			</div>
			<div class="col-md-4">
				<BarCard title="AVERAGE BASKET (K)" :data="weekly.basket" :width="500" :height="280"/>
			</div>
			<div class="col-md-4">
				<BarCard title="WASTE (M)" :data="weekly.waste" :width="500" :height="280"/>
			</div>
	</div>
	</div>
</template>

<script>
import Bright from '@/components/page/Bright.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListCompare from '@/views/pages/ListCompare.vue'

export default{
	extends: Bright,
	components:{
		ListCompare,
		BarCard
	},
    mounted(){
		this.loadYTD();
		this.loadWeekly();
    },
    methods:{
	}
}

</script>